import { memo } from 'react';
import { FileText, ImageIcon, FileSpreadsheet, Presentation, Archive, FileCode2, Film, Music2, File } from 'lucide-react';

const STYLES = {
    image: [ImageIcon, 'border-cyan-200 bg-cyan-50 text-cyan-700'],
    pdf: [FileText, 'border-red-200 bg-red-50 text-red-700'],
    document: [FileText, 'border-blue-200 bg-blue-50 text-blue-700'],
    spreadsheet: [FileSpreadsheet, 'border-emerald-200 bg-emerald-50 text-emerald-700'],
    presentation: [Presentation, 'border-orange-200 bg-orange-50 text-orange-700'],
    archive: [Archive, 'border-amber-200 bg-amber-50 text-amber-700'],
    code: [FileCode2, 'border-indigo-200 bg-indigo-50 text-indigo-700'],
    video: [Film, 'border-rose-200 bg-rose-50 text-rose-700'],
    audio: [Music2, 'border-teal-200 bg-teal-50 text-teal-700'],
    text: [FileText, 'border-slate-200 bg-slate-50 text-slate-600'],
    file: [File, 'border-slate-200 bg-slate-50 text-slate-600'],
};

export const wallFileType = (file) => {
    const filename = file.filename || file.original_filename || '';
    const extension = (file.extension || (filename.includes('.') ? filename.split('.').pop() : '')).toLowerCase();
    const group = /^(png|jpe?g|gif|webp|bmp|tiff?|heic|heif|svg)$/.test(extension) ? 'image'
        : extension === 'pdf' ? 'pdf'
        : /^(xls[xm]?|ods|csv)$/.test(extension) ? 'spreadsheet'
        : /^(pptx?|odp)$/.test(extension) ? 'presentation'
        : /^(docx?|odt|rtf)$/.test(extension) ? 'document'
        : /^(zip|rar|7z|tar|gz)$/.test(extension) ? 'archive'
        : /^(json|xml|html|css|js|py)$/.test(extension) ? 'code'
        : /^(mp4|mov|webm|avi|mkv|m4v)$/.test(extension) ? 'video'
        : /^(mp3|wav|ogg|oga|m4a|aac|opus)$/.test(extension) ? 'audio'
        : /^(txt|md)$/.test(extension) ? 'text'
        : STYLES[file.kind] ? file.kind : 'file';
    return { group, label: extension && extension.length <= 5 ? extension.toUpperCase() : 'FICH.' };
};

// Aucun effet, aucun réseau, aucun décodage de fichier pour afficher le mur.
export const WallFileIcon = memo(function WallFileIcon({ file }) {
    const { group, label } = wallFileType(file);
    const [Icon, colors] = STYLES[group];
    return <span className={`flex h-9 w-9 shrink-0 flex-col items-center justify-center gap-0.5 rounded border ${colors}`} aria-hidden="true" data-testid={`wall-file-icon-${file.id}`} data-file-type={group}>
        <Icon className="h-4 w-4" strokeWidth={1.65} />
        <span className="text-[7px] font-bold leading-none" data-testid={`wall-file-icon-format-${file.id}`}>{label}</span>
    </span>;
});